import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';

import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';

export async function fetchAllWishListItems() {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching Wishlist from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("home-page-featured-listings.json");

      //if (data && data[appState.SiteLanguageCookie]) {
      //    const listings = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded featured Listings for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    return listings;
      //} else {
      //    console.warn(`⚠️ No featured Listings found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}

      return [];
    } else {
      //const storageKey = `homePageFeaturedListings_${appState.SiteLanguageCookie}`;
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000;

      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded featured Listings from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllWishListItemsCanBuyNowOnlyAsync?loggedInUserID=${appState.MyLoggedInUserID}&buyingEntityID=${appState.MyBuyingEntityID}&buyingEntityType=${appState.MyBuyingEntityType}&languageCode=${appState.SiteLanguageCookie}`;

      //  const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllWishListItemsCanBuyNowOnlyAsync?loggedInUserID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityType=Guest&languageCode=en`;

      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch Wishlist from server');

      const featuredListings = await response.json();

      //// Save to localStorage
      //saveToLocalStorage(storageKey, featuredListings);
      //saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      //console.log("🌐 Fetched featured Listings from the server");
      return featuredListings;
    }
  } catch (error) {
    console.error('❌ Error fetching Wishlist:', error);
    return [];
  }
}

export async function fetchRemoveItemFromWishList(finalSelectedSKU) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching Wishlist from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("home-page-featured-listings.json");

      //if (data && data[appState.SiteLanguageCookie]) {
      //    const listings = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded featured Listings for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    return listings;
      //} else {
      //    console.warn(`⚠️ No featured Listings found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}

      return [];
    } else {
      //const storageKey = `homePageFeaturedListings_${appState.SiteLanguageCookie}`;
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000;

      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded featured Listings from cache");
      //    return cached;
      //}
      //AddSKUToWishListAsync?skuID=222&quantity=2222&customerID=2222&buyingEntityID=2222&buyingEntityType=2222&DepartmentID=222&CategoryID=222&ProductID=222&ShippingMethodID=222&languageCode=222

      alert(` 2 removing from wishlist ${finalSelectedSKU}`);

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/RemoveSKUFromWishListAsync?skuID=${finalSelectedSKU}&customerID=${appState.MyLoggedInUserID}&buyingEntityID=${appState.MyBuyingEntityID}&buyingEntityType=${appState.MyBuyingEntityType}&languageCode=${appState.SiteLanguageCookie}`;

      //  const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllWishListItemsCanBuyNowOnlyAsync?loggedInUserID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityType=Guest&languageCode=en`;

      // alert(` 2 removing from wishlist ${apiEndPoint}`);

      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to add item to Wishlist from server');

      const featuredListings = await response.json();

      //// Save to localStorage
      //saveToLocalStorage(storageKey, featuredListings);
      //saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      //console.log("🌐 Fetched featured Listings from the server");
      return featuredListings;
    }
  } catch (error) {
    console.error('❌ Error removing from Wishlist:', error);
    return [];
  }
}

export async function fetchCheckIfSKUIsInWishList(finalSelectedSKU) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching Wishlist from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("home-page-featured-listings.json");

      //if (data && data[appState.SiteLanguageCookie]) {
      //    const listings = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded featured Listings for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    return listings;
      //} else {
      //    console.warn(`⚠️ No featured Listings found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}

      return [];
    } else {
      //const storageKey = `homePageFeaturedListings_${appState.SiteLanguageCookie}`;
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000;

      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded featured Listings from cache");
      //    return cached;
      //}
      //AddSKUToWishListAsync?skuID=222&quantity=2222&customerID=2222&buyingEntityID=2222&buyingEntityType=2222&DepartmentID=222&CategoryID=222&ProductID=222&ShippingMethodID=222&languageCode=222

      //alert(` 2 checking if sku is in wishlist ${finalSelectedSKU}`);

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/CheckIfSKUIsInWishListAsync?skuID=${finalSelectedSKU}&loggedInUserID=${appState.MyLoggedInUserID}&buyingEntityID=${appState.MyBuyingEntityID}&buyingEntityType=${appState.MyBuyingEntityType}&languageCode=${appState.SiteLanguageCookie}`;

      //  const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllWishListItemsCanBuyNowOnlyAsync?loggedInUserID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityType=Guest&languageCode=en`;

      // alert(` 2 removing from wishlist ${apiEndPoint}`);

      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to check if sku is in Wishlist from server');

      const featuredListings = await response.json();

      //// Save to localStorage
      //saveToLocalStorage(storageKey, featuredListings);
      //saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      //console.log("🌐 Fetched featured Listings from the server");
      return featuredListings;
    }
  } catch (error) {
    console.error('❌ Error check if sku is in Wishlist:', error);
    return [];
  }
}

export async function fetchAddItemToWishList(
  qyt,
  finalSelectedSKU,
  departmentID,
  categoryID,
  productID,
  shippingMethodID
) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching Wishlist from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("home-page-featured-listings.json");

      //if (data && data[appState.SiteLanguageCookie]) {
      //    const listings = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded featured Listings for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    return listings;
      //} else {
      //    console.warn(`⚠️ No featured Listings found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}

      return [];
    } else {
      //const storageKey = `homePageFeaturedListings_${appState.SiteLanguageCookie}`;
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000;

      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded featured Listings from cache");
      //    return cached;
      //}
      //AddSKUToWishListAsync?skuID=222&quantity=2222&customerID=2222&buyingEntityID=2222&buyingEntityType=2222&DepartmentID=222&CategoryID=222&ProductID=222&ShippingMethodID=222&languageCode=222

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/AddSKUToWishListAsync?skuID=${finalSelectedSKU}&quantity=${qyt}&customerID=${appState.MyLoggedInUserID}&buyingEntityID=${appState.MyBuyingEntityID}&buyingEntityType=${appState.MyBuyingEntityType}&DepartmentID=${departmentID}&CategoryID=${categoryID}&ProductID=${productID}&ShippingMethodID=${shippingMethodID}&languageCode=${appState.SiteLanguageCookie}`;

      //  const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllWishListItemsCanBuyNowOnlyAsync?loggedInUserID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityType=Guest&languageCode=en`;

      //  alert(` 2 Adding to wishlist ${apiEndPoint}`);

      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to add item to Wishlist from server');

      const featuredListings = await response.json();

      //// Save to localStorage
      //saveToLocalStorage(storageKey, featuredListings);
      //saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      //console.log("🌐 Fetched featured Listings from the server");
      return featuredListings;
    }
  } catch (error) {
    console.error('❌ Error addint itm to Wishlist:', error);
    return [];
  }
}

export async function fetchAllShoppingCartItemsLightForTopCart() {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching Wishlist from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("home-page-featured-listings.json");

      //if (data && data[appState.SiteLanguageCookie]) {
      //    const listings = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded featured Listings for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    return listings;
      //} else {
      //    console.warn(`⚠️ No featured Listings found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}

      return [];
    } else {
      //const storageKey = `homePageFeaturedListings_${appState.SiteLanguageCookie}`;
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000;

      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded featured Listings from cache");
      //    return cached;
      //}

      // allShoppingCartData = await _shoppingCartDataService.GetAllDataAndListModelsForShoppingCartAsync(_myUserIdentityInformationService.MyUserID, _myUserIdentityInformationService.MyBuyingEntityID, _myUserIdentityInformationService.MyBuyingEntityType, _myUserIdentityInformationService.SiteLanguageCookie, _myUserIdentityInformationService.SiteShipToCountryIDCookie, _myUserIdentityInformationService.SiteShipToStateIDCookie, _myUserIdentityInformationService.SiteShipToCityIDCookie, _currentComponentCancellationTokenSource.Token);

      //curl - X 'GET' \
      //'https://localhost:7009/api/ShoppingCartDataService/GetAllDataAndListModelsForShoppingCartAsync?loggedInUserID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityType=Guest&languageCode=en&shipToCountryID=237&shipToStateID=0&shipToCityID=0' \
      //-H 'accept: text/plain'

      /* const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllDataAndListModelsForShoppingCartAsync?loggedInUserID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityType=Guest&languageCode=en&shipToCountryID=237&shipToStateID=0&shipToCityID=0`;*/

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllCartItemsCanBuyNowOnlyAsync?loggedInUserID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityType=Guest&languageCode=en`;

      //listOfShoppingCartItems = await _shoppingCartDataService.GetAllCartItemsCanBuyNowOnlyAsync(_myUserIdentityInformationService.MyUserID, _myUserIdentityInformationService.MyBuyingEntityID, _myUserIdentityInformationService.MyBuyingEntityType, _myUserIdentityInformationService.SiteLanguageCookie, _currentComponentCancellationTokenSource.Token);

      /*const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllDataAndListModelsForShoppingCartAsync?&customerID=${appState.MyLoggedInUserID}&buyingEntityID=${appState.MyBuyingEntityID}&buyingEntityType=${appState.MyBuyingEntityType}&DepartmentID=${departmentID}&CategoryID=${categoryID}&ProductID=${productID}&ShippingMethodID=${shippingMethodID}&languageCode=${appState.SiteLanguageCookie}`;*/

      //  const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllWishListItemsCanBuyNowOnlyAsync?loggedInUserID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityType=Guest&languageCode=en`;

      //  alert(` 2 Adding to wishlist ${apiEndPoint}`);

      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to checkout page shopping cart data from server');

      const featuredListings = await response.json();

      //// Save to localStorage
      //saveToLocalStorage(storageKey, featuredListings);
      //saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      //console.log("🌐 Fetched featured Listings from the server");
      return featuredListings;
    }
  } catch (error) {
    console.error('❌ Error fetching checkout page shopping cart data:', error);
    return [];
  }
}

export async function fetchAllShoppingCartItems() {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching Wishlist from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("home-page-featured-listings.json");

      //if (data && data[appState.SiteLanguageCookie]) {
      //    const listings = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded featured Listings for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    return listings;
      //} else {
      //    console.warn(`⚠️ No featured Listings found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}

      return [];
    } else {
      //const storageKey = `homePageFeaturedListings_${appState.SiteLanguageCookie}`;
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000;

      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded featured Listings from cache");
      //    return cached;
      //}

      // allShoppingCartData = await _shoppingCartDataService.GetAllDataAndListModelsForShoppingCartAsync(_myUserIdentityInformationService.MyUserID, _myUserIdentityInformationService.MyBuyingEntityID, _myUserIdentityInformationService.MyBuyingEntityType, _myUserIdentityInformationService.SiteLanguageCookie, _myUserIdentityInformationService.SiteShipToCountryIDCookie, _myUserIdentityInformationService.SiteShipToStateIDCookie, _myUserIdentityInformationService.SiteShipToCityIDCookie, _currentComponentCancellationTokenSource.Token);

      //curl - X 'GET' \
      //'https://localhost:7009/api/ShoppingCartDataService/GetAllDataAndListModelsForShoppingCartAsync?loggedInUserID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityType=Guest&languageCode=en&shipToCountryID=237&shipToStateID=0&shipToCityID=0' \
      //-H 'accept: text/plain'

      /* const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllDataAndListModelsForShoppingCartAsync?loggedInUserID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityType=Guest&languageCode=en&shipToCountryID=237&shipToStateID=0&shipToCityID=0`;*/

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllShoppingCartItemsForUserAsync?loggedInUserID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityID=659553a6-f0bc-4351-99d3-81d41e3b4228&buyingEntityType=Guest&languageCode=en&shipToCountryID=237&shipToStateID=0&shipToCityID=0`;

      /*const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllDataAndListModelsForShoppingCartAsync?&customerID=${appState.MyLoggedInUserID}&buyingEntityID=${appState.MyBuyingEntityID}&buyingEntityType=${appState.MyBuyingEntityType}&DepartmentID=${departmentID}&CategoryID=${categoryID}&ProductID=${productID}&ShippingMethodID=${shippingMethodID}&languageCode=${appState.SiteLanguageCookie}`;*/

      //  const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/ShoppingCartDataService/GetAllWishListItemsCanBuyNowOnlyAsync?loggedInUserID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityID=BF1EBBF1-17C4-4F5A-89B3-7D875CE799F4&buyingEntityType=Guest&languageCode=en`;

      //  alert(` 2 Adding to wishlist ${apiEndPoint}`);

      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to checkout page shopping cart data from server');

      const featuredListings = await response.json();

      //// Save to localStorage
      //saveToLocalStorage(storageKey, featuredListings);
      //saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      //console.log("🌐 Fetched featured Listings from the server");
      return featuredListings;
    }
  } catch (error) {
    console.error('❌ Error fetching checkout page shopping cart data:', error);
    return [];
  }
}
